const _IpayAfrica = IpayAfrica;
export { _IpayAfrica as IpayAfrica };

function IpayAfrica(live=false) {

	const ipay = {
		vendor_id: 'adenzo',
		hash_key: 'fchguhuy989656hg8yug',
		live: (!live) ? 0 : 1
	};

	return {

		post: async function (options, cbk) {

			const payment_options = {
				live: ipay.live
				, bonga: 0
				, autopay: 0
				, fname: options.first_name || ''
				, lname: options.last_name || ''
				, oid: options.order_id || ''
				, inv: options.invoice_id || options.order_id
				, ttl: (!ipay.live) ? 5 : options.amount || 0
				, tel: options.telephone || ''
				, eml: options.email || ''
				, vid: ipay.vendor_id
				, curr: options.currency || 'KES'
				, p1: options.param1 || ''
				, p2: options.param2 || ''
				, p3: options.param3 || ''
				, p4: options.param3 || ''
				, cbk: 'https://adenzo.co.ke/ipay'
				, cst: options.sendEmail || 1
				, crl: options.curl || 0
			};

			await fetch_hash(payment_options,ipay.hash_key);

			const ipay_redirect_url = computeUri(payment_options);

			return (!!cbk) ? cbk(ipay_redirect_url) : ipay_redirect_url;

		}
	};

}

async function fetch_hash(options, hash_key) {

	const { error, hash, request } = await post_data(options,hash_key);

	if (!!error) return alert('Payment Error: \n'+request);

	options.cbk = encodeURI(options.cbk);

	options.hsh = hash;

}

async function post_data(data, hash_key) {

	const base_url = 'https://adenzo.co.ke/hash';

	const url_params = new URLSearchParams({...data, key: hash_key});

	const headers = {'Content-type': 'application/x-www-form-urlencoded; charset=UTF-8'};

	const response = await fetch(`${base_url}?${url_params}`, { headers: new Headers(headers) });

	return response.json();

}

function computeUri(request,raw) {

	const url_params = new URLSearchParams(request);

	const base_url = 'https://payments.ipayafrica.com/v3/ke';

	return (!!raw) ? url_params : `${base_url}?${url_params}`;

}
